import { render } from "./TicketDetailsPage.vue?vue&type=template&id=6d1b993a&scoped=true"
import script from "./TicketDetailsPage.vue?vue&type=script&lang=js"
export * from "./TicketDetailsPage.vue?vue&type=script&lang=js"

import "./TicketDetailsPage.vue?vue&type=style&index=0&id=6d1b993a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1b993a"]])

export default __exports__